module.exports = __webpack_public_path__ + "static/media/edit.9fee4ab7.svg";